module.exports = __webpack_public_path__ + "d4b85896c9b1db7f3c15d8e0b37c400d.png";